import React, { useState, useEffect } from 'react';

import priorityService from '../../service/priority.service';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';
import { ColorPicker } from '../../config/ColorPicker';
import { dataGridColumns } from '../../utils/helper';

import AddDialog from './AddDialog';
import { ButtonUI, DataGridUI, DataGridIdentifiers, DeleteDialogUI, ColorPickerUI } from '../Interface';

export default function FormTable(props) {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [removeId, setRemoveId] = useState(null);
  const [addModalShow, setAddModalShow] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    const defVal = [props.selectedValues?.defaultValue ?? undefined];
    setSelectedRows(defVal);
    props.setRefetchTable(true);
  }, [props.selectedValues]);

  const removePriorityItem = async (itemId) => {
    priorityService
      .deletePriorityItem(itemId)
      .then(() => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.WARNING,
        });
        props.setpriroityList(props.priroityList.filter((item) => item.itemId !== itemId));
        props.setRefetchTable(true);
      })
      .finally(() => {
        setShowDeleteDialog(false);
      });
  };

  const deleteIcon = (props, params) => {
    return (
      <div
        disabled={props.disabled}
        className={props.disabled ? 'hidden' : 'block cursor-pointer'}
        onClick={(e) => {
          e.stopPropagation();
          setRemoveId(params.row.itemId);
          setShowDeleteDialog(true);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </div>
    );
  };

  const handleRowClick = (params) => {
    if (!props.viewField) {
      setSelectedItem(params.row);
      setAddModalShow(true);
    }
  };

  const addDefaultValue = async (itemId) => {
    try {
      await priorityService.updateDefaultValue(props.priorityId, itemId);
      if (itemId !== null) {
        addNotification({
          content: 'Alapértelmezett érték frissítve!',
          type: NotificationType.SUCCESS,
        });
      }
    } catch (error) {
      addNotification({
        content: 'Hiba történt az alapértelmezett érték frissítése közben!',
        type: NotificationType.ERROR,
      });
    }
  };

  const columns = dataGridColumns([
    {
      field: 'itemId',
      headerName: 'Azonosító',
      flex: 1,
    },
    {
      field: 'itemName',
      headerName: 'Megnevezés',
      flex: 1,
      valueGetter: (params) => {
        return params.value ? params.value : 'Nincs adat.';
      },
    },
    {
      field: 'color',
      headerName: 'Beállított szín',
      flex: 1,
      renderCell: (params) => {
        const colorItem = ColorPicker.find((col) => col.colorName === params.value);
        return <ColorPickerUI color={colorItem ? colorItem.colorCode : '#FFFFFF'} disabled />;
      },
    },
    {
      field: 'removeTag',
      headerName: '',
      flex: 0.4,
      renderCell: (params) => {
        return deleteIcon(props, params);
      },
    },
  ]);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">Elemek</h1>
          <p className="mt-2 text-sm text-gray-700">További elemek hozzáadása.</p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <ButtonUI
            text="Hozzáadás"
            type="button"
            disabled={props.disabled}
            onClick={() => {
              setAddModalShow(true);
            }}
            className="bg-success block rounded-md px-3 disabled:cursor-not-allowed disabled:opacity-50 py-2 text-center text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          ></ButtonUI>
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle ">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <DataGridUI
                datagridIdentifier={DataGridIdentifiers.PriorityFormTable}
                sx={{
                  height: 440,
                  width: '100%',
                  '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
                    display: 'none',
                  },
                  '& .MuiDataGrid-columnHeaderDraggableContainer': {
                    backgroundColor: '#CEDFE8',
                  },
                }}
                columns={columns}
                rows={props.priroityList}
                getRowId={(row) => row.itemId}
                onRowClick={handleRowClick}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                  if (newRowSelectionModel.length > 0) {
                    setSelectedRows([newRowSelectionModel[newRowSelectionModel.length - 1]]);
                    addDefaultValue(newRowSelectionModel[newRowSelectionModel.length - 1]);
                  } else {
                    setSelectedRows([]);
                    addDefaultValue(null);
                  }
                }}
                selectedRows={selectedRows}
                checkboxSelection
                isRowSelectable={(params) => !props.viewField}
                rowSelectionModel={selectedRows}
                disableRowSelectionOnClick={true}
              />
            </div>
          </div>
        </div>
      </div>
      <DeleteDialogUI
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
        handleRemoveElement={() => removePriorityItem(removeId)}
      />

      <AddDialog
        show={addModalShow}
        priroityList={props.priroityList}
        setpriroityList={props.setpriroityList}
        onHide={() => {
          setAddModalShow(false);
          setSelectedItem({});
        }}
        priorityId={props.priorityId}
        setRefetchTable={props.setRefetchTable}
        selectedItem={selectedItem}
      />
    </div>
  );
}
